module.exports = __webpack_public_path__ + "static/media/disable-sound-icon.9f84bcbd.svg";